import React from 'react/addons';

const ErrorPage = React.createClass( {
	displayName: 'ErrorPage',

	render() {
		return <h1>Not Found</h1>;
	}
} );

export default ErrorPage;



/** WEBPACK FOOTER **
 ** ./client/error-page.jsx
 **/